import Page from 'components/layout/Page';
import { Heading1 } from 'components/shared/Typography.styled';
import { StyledCookies } from './CookiesComponent.styled';

const CookiesComponent: React.FC = () => {
  return (
    <Page hasScrollTop>
      <StyledCookies>
        <Heading1 editorial>Cookies</Heading1>

        <p>
          This website may use cookies to offer faster navigation and improve
          your user experience.
        </p>

        <p>
          Cookies are small files for storage and data retrieval that are
          installed on your computer for a stated purpose; in no way will our
          cookies process personal data or compromise your privacy.
        </p>

        <p>
          If you decide not to accept our cookies, you may still use our website
          as usual, although it is possible that your user experience will be
          slightly affected.
        </p>

        <p>
          Your browser on occasions can generate a message that will give you
          the opportunity to object to the use of these cookies. On the
          assumption that your browser does not provide this option
          automatically, you can prevent the installation of cookies with the
          following instructions:
        </p>

        <ul>
          <li>
            Internet Explorer:&nbsp;
            <a
              href="https://support.microsoft.com/en-US/help/17442/windows-internet-explorer-delete-managecookies"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://support.microsoft.com/en-US/help/17442/windows-internet-explorer-delete-managecookies
            </a>
          </li>
          <li>
            Firefox:&nbsp;
            <a
              href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences
            </a>
          </li>
          <li>
            Chrome:&nbsp;
            <a
              href="https://support.google.com/chrome/answer/95647?hl=en"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://support.google.com/chrome/answer/95647?hl=en
            </a>
          </li>
          <li>
            Opera:&nbsp;
            <a
              href="http://help.opera.com/Windows/11.50/en/cookies.html"
              target="_blank"
              rel="noreferrer noopener"
            >
              http://help.opera.com/Windows/11.50/en/cookies.html
            </a>
          </li>
          <li>
            Safari:&nbsp;
            <a
              href="https://support.apple.com/en-us/HT201265"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://support.apple.com/en-us/HT201265
            </a>
          </li>
        </ul>

        <p>
          If you use another browser, you can get more information about
          configuring the installation of cookies through the help section or
          through the customer service of the browser. If you need help to carry
          out the cookie settings in your browser, please send an e-mail to (
          <a
            rel="noreferrer noopener"
            href="mailto:hello@getmanfred.com"
            target="_blank"
          >
            hello@getmanfred.com
          </a>
          ) and we will contact you as soon as possible with the necessary
          information.
        </p>
      </StyledCookies>
    </Page>
  );
};

export default CookiesComponent;
